'use client';
import React from 'react';
import buildLinkObj from '@repo/ui/src/functions/build-link';
import MenuItemWithCheck from '@components/shared/MenuItemWithCheck';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LinkProps } from '@repo/ui/src/types/link';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';
import { AlternateSizeContainer } from './styles';

interface Props {
  sizes: Array<LinkProps>;
  setIsLoading: (isLoading: boolean) => void;
}

const AlternateSizes = ({ sizes, setIsLoading }: Props) => {
  const { path, push } = useCurrentUrl();

  const { alternativeSizes } = React.useMemo(() => {
    const linkObjs = sizes.map((link) => {
      return buildLinkObj(link);
    });

    const alternativeSizes = linkObjs.sort((a, b) => {
      if (a.href.indexOf(path) >= 0) return -1;
      if (b.href.indexOf(path) >= 0) return 1;
      return 0;
    });

    return { alternativeSizes };
  }, [sizes, path]);

  return (
    <AlternateSizeContainer
      value={path}
      onChange={(e) => {
        const value = e?.target.value as string;
        setIsLoading(true);
        push(value);
      }}
      aria-label="select size"
      variant="outlined"
      IconComponent={ExpandMoreIcon}
      inputProps={{
        title: 'Menu-Select-Dropdown',
      }}
    >
      {alternativeSizes.map((size) => (
        <MenuItemWithCheck key={size.href} value={size.href} selected={path === size.href}>
          {size.text}
        </MenuItemWithCheck>
      ))}
    </AlternateSizeContainer>
  );
};

export default AlternateSizes;
